import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NavBar from "./Components/NavBar";

import Home from "./Components/Home";
import Projects from "./Components/Projects";
import Creatives from "./Components/Creatives"
import Quotes from "./Components/Quotes";
import Resume from "./Components/Resume";

function App() {
  return (
    <Router>
      <NavBar />
      <div className="app-container">
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/PROJECTS" element={<Projects />} />
          <Route path="/CREATIVES" element={<Creatives />} />
          <Route path="/QUOTES" element={<Quotes />} />
          <Route path="/RESUME" element={<Resume />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
